import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const ForgotPassword = () => {
  const navigate = useNavigate();
  // Grab the reset password code from the ?code= query param
  const [params] = useSearchParams();
  const code = params.get("code");

  // Redirect to login with the code if there is one.
  // If there is no code, just navigate to the landing page.
  useEffect(() => {
    if (!code) navigate("/");
    navigate(`/login?reset=${code}`);
  }, [code, navigate]);

  // As we're just redirecting, we don't need to render anything
  return <></>;
};

export default ForgotPassword;
